import { Component, Input } from '@angular/core';

// "★ 4.4" style rating display with auto-coloured tone.
@Component({
  selector: 'tangram-analytics-rating-value',
  template: `<span class="rating-value"
                   *ngIf="rating > 0; else empty"
                   [class.rating--top]="effectiveTone === 'top'"
                   [class.rating--mid]="effectiveTone === 'mid'"
                   [class.rating--low]="effectiveTone === 'low'">★ {{ rating | number:'1.1-1' }}</span>
             <ng-template #empty><span class="muted-text">No data</span></ng-template>`,
  styleUrls: ['./analytics-rating-value.component.scss']
})
export class AnalyticsRatingValueComponent {
  @Input() rating = 0;
  @Input() forceTone: 'top' | 'mid' | 'low' | null = null;

  get effectiveTone(): 'top' | 'mid' | 'low' {
    if (this.forceTone) { return this.forceTone; }
    if (this.rating >= 4) { return 'top'; }
    if (this.rating >= 3) { return 'mid'; }
    return 'low';
  }
}
